import { type RefObject, useEffect, useState } from 'react';

const SCROLL_BOTTOM_THRESHOLD = 1;

export const useShowOverlay = (
    tbodyRef: RefObject<HTMLTableSectionElement | null>,
) => {
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);

    useEffect(() => {
        const tbody = tbodyRef.current;

        if (!tbody) {
            return;
        }

        const updateOverlayVisibility = () => {
            const isScrolledToBottom =
                tbody.scrollTop + tbody.clientHeight >=
                tbody.scrollHeight - SCROLL_BOTTOM_THRESHOLD;

            setIsOverlayVisible(
                tbody.scrollHeight > tbody.clientHeight &&
                    !isScrolledToBottom,
            );
        };

        updateOverlayVisibility();

        tbody.addEventListener('scroll', updateOverlayVisibility);

        return () =>
            tbody.removeEventListener('scroll', updateOverlayVisibility);
    }, [tbodyRef]);

    return isOverlayVisible;
};
